module.exports = __webpack_public_path__ + "img/bookcases-and-cabinets.e3a5e65.png";